import { DescriptionPage_CourseType as CourseType } from '__generated__/graphql-types';

import routeConfig from 'bundles/unified-description-page-common/constants/routeConfig';

const getProductPath = (courseType?: CourseType | null) => {
  if (courseType === CourseType.Project || courseType === CourseType.RhymeProject) {
    return routeConfig.PROJECTS.pathname;
  } else {
    return routeConfig.COURSE.pathname;
  }
};

export const getConsumerRouteForCourseProducts = (slug: string, courseType?: CourseType | null, search?: string) => {
  let url = `/${getProductPath(courseType)}/${slug}`;

  if (search) {
    url += `${search}`;
  }

  return url;
};

export const getEnterpriseRouteForCourseProducts = (
  slug: string,
  programSlug?: string,
  courseType?: CourseType,
  search?: string,
  orgSlug?: string
) => {
  // Without a program or org context there is no enterprise base path; fall back to the
  // consumer route rather than producing a broken "/programs/undefined/..." URL.
  if (!programSlug && !orgSlug) {
    return getConsumerRouteForCourseProducts(slug, courseType, search);
  }

  const basePath = orgSlug ? `/organizations/${orgSlug}` : `/programs/${programSlug}`;
  let url = `${basePath}/${getProductPath(courseType)}/${slug}`;

  if (search) {
    url += `${search}`;
  }

  return url;
};
